import { useEffect, useState } from 'react';
import { getTheme, onThemeChange } from './fonts';

/**
 * The active theme, as React state.
 *
 * The DOM re-themes itself through CSS custom properties, but WebGL can't read
 * those — fog colours, light intensities and blend modes are plain JS values
 * that have to be swapped by hand. This is how the 3D scenes follow along.
 */
export default function useTheme() {
  const [theme, setTheme] = useState(() =>
    typeof document === 'undefined' ? 'dark' : getTheme()
  );
  useEffect(() => onThemeChange((e) => setTheme(e.detail)), []);
  return theme;
}
